import OpcoesLiquidacaoBaseModel from "../opcoesLiquidacaoBaseModel";

export default class FaturamentoNfeModel extends OpcoesLiquidacaoBaseModel {
    nFat: string = null;
    valorOriginal: number = null;
    valorDesconto?: number = null;
    valorLiquido: number = null;
}
